export interface BackOfficeRuntimeEnv {
  BACKEND_BASE_URL?: string;
  BACKOFFICE_IDLE_TIMEOUT_MINUTES?: string | number;
  BACKOFFICE_WARNING_BEFORE_LOGOUT_SECONDS?: string | number;
  BACKOFFICE_ENABLE_IDLE_TIMEOUT?: string | boolean;
  BACKOFFICE_KEEP_ALIVE_ENABLED?: string | boolean;
}

declare global {
  interface Window {
    __CC_BACKOFFICE_ENV__?: BackOfficeRuntimeEnv;
  }
}

export function getBackOfficeRuntimeEnv(): BackOfficeRuntimeEnv {
  return typeof window === 'undefined' ? {} : window.__CC_BACKOFFICE_ENV__ ?? {};
}

export function parseRuntimeNumber(value: unknown): number | null {
  if (typeof value === 'number') {
    return Number.isFinite(value) && value > 0 ? value : null;
  }

  if (typeof value === 'string') {
    const parsed = Number(value.trim());
    return Number.isFinite(parsed) && parsed > 0 ? parsed : null;
  }

  return null;
}

export function parseRuntimeBoolean(value: unknown, fallback: boolean): boolean {
  if (typeof value === 'boolean') {
    return value;
  }

  if (typeof value === 'string') {
    const normalized = value.trim().toLowerCase();
    if (['true', '1', 'yes', 'on'].includes(normalized)) {
      return true;
    }
    if (['false', '0', 'no', 'off'].includes(normalized)) {
      return false;
    }
  }

  return fallback;
}
